var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//  @jsx h

import { bem } from '@nrk/dh-utils';
import { h } from 'preact';
import PureComponent from '../../lib/preact-pure-component';
import Video from '../Video';
var style = {
  'smartVideo': 'dhfc-1_0_0-beta_26-smartVideo',
  'smartVideo__720p': 'dhfc-1_0_0-beta_26-smartVideo__720p',
  'smartVideo--horizontal': 'dhfc-1_0_0-beta_26-smartVideo--horizontal',
  'smartVideo--1080p': 'dhfc-1_0_0-beta_26-smartVideo--1080p',
  'smartVideo__960p': 'dhfc-1_0_0-beta_26-smartVideo__960p',
  'smartVideo__1080p': 'dhfc-1_0_0-beta_26-smartVideo__1080p'
};


var THRESHOLD_1080P = 960;
var THRESHOLD_HORIZONTAL = 2 / 3;

var SmartVideo = function (_PureComponent) {
  _inherits(SmartVideo, _PureComponent);

  function SmartVideo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SmartVideo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmartVideo.__proto__ || Object.getPrototypeOf(SmartVideo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      time: 0
    }, _this.handleTimeupdate = function (time) {
      var onTimeupdate = _this.props.onTimeupdate;


      _this.setState({ time: time });

      if (onTimeupdate) {
        onTimeupdate(time);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SmartVideo, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevIsHorizontal = prevProps.viewport.width / prevProps.viewport.height >= THRESHOLD_HORIZONTAL;
      var isHorizontal = this.props.viewport.width / this.props.viewport.height >= THRESHOLD_HORIZONTAL;

      var prevIs1080p = prevProps.viewport.width >= THRESHOLD_1080P;
      var is1080p = this.props.viewport.width >= THRESHOLD_1080P;

      if (prevIsHorizontal !== isHorizontal || is1080p !== prevIs1080p) {
        this.seek(this.state.time);
      }
    }
  }, {
    key: 'seek',
    value: function seek(time) {
      var viewport = this.props.viewport;

      var isHorizontal = viewport.width / viewport.height >= THRESHOLD_HORIZONTAL;
      var is1080p = viewport.width >= THRESHOLD_1080P;

      if (isHorizontal) {
        if (is1080p) {
          this.resolution1080p.seek(time);
        } else {
          this.resolution720p.seek(time);
        }
      } else {
        this.resolution960p.seek(time);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          playing = _props.playing,
          resolution720p = _props.resolution720p,
          resolution960p = _props.resolution960p,
          resolution1080p = _props.resolution1080p,
          viewport = _props.viewport,
          restProps = _objectWithoutProperties(_props, ['playing', 'resolution720p', 'resolution960p', 'resolution1080p', 'viewport']);

      if (!resolution720p) {
        throw new Error('Missing `resolution720p` property');
      }

      if (!resolution960p) {
        throw new Error('Missing `resolution960p` property');
      }

      if (!resolution1080p) {
        throw new Error('Missing `resolution1080p` property');
      }

      var isValidViewport = viewport.width > -1 && viewport.height > -1;
      var isHorizontal = viewport.width / viewport.height >= THRESHOLD_HORIZONTAL;
      var is1080p = isHorizontal && viewport.width >= THRESHOLD_1080P;
      var className = '' + bem(style.smartVideo, {
        '1080p': is1080p,
        horizontal: isHorizontal
      }) + (this.props.className ? ' ' + this.props.className : '');

      return h(
        'div',
        { className: className },
        h(Video, _extends({}, resolution720p, restProps, {
          className: style.smartVideo__720p,
          playing: isValidViewport && isHorizontal && !is1080p && playing,
          onTimeupdate: this.handleTimeupdate,
          ref: function ref(resolution720p) {
            return _this2.resolution720p = resolution720p;
          }
        })),
        h(Video, _extends({}, resolution960p, restProps, {
          className: style.smartVideo__960p,
          playing: isValidViewport && !isHorizontal && !is1080p && playing,
          onTimeupdate: this.handleTimeupdate,
          ref: function ref(resolution960p) {
            return _this2.resolution960p = resolution960p;
          }
        })),
        h(Video, _extends({}, resolution1080p, restProps, {
          className: style.smartVideo__1080p,
          playing: isValidViewport && isHorizontal && is1080p && playing,
          onTimeupdate: this.handleTimeupdate,
          ref: function ref(resolution1080p) {
            return _this2.resolution1080p = resolution1080p;
          }
        }))
      );
    }
  }]);

  return SmartVideo;
}(PureComponent);

export default SmartVideo;


// WEBPACK FOOTER //
// ./node_modules/@nrk/dh-feature-components/dist/module/video/SmartVideo/index.js